import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHandlers, useSite } from '../../../context/page-context';
import { track } from '../../../lib/mixpanel';
import { useBillingApi } from './use-billing-api';
import { QK_BILLING_DATA } from './use-billing-data';

type Options = {
  onError?: (error: unknown) => void;
};

export function useInitiateDevelopmentPlanFlow(options: Options = {}) {
  const { billingApi } = useBillingApi();
  const { navigationHandler } = useHandlers();
  const site = useSite();
  const { siteId } = site;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => billingApi.assignDevelopmentPlan(siteId),
    onMutate: () => {
      track(site, 'Development Plan Activation Initiated', {});
    },
    onSuccess: () => {
      track(site, 'Development Plan Activated', {});
      void queryClient.invalidateQueries({ queryKey: QK_BILLING_DATA(siteId) });

      navigationHandler.navigateById('onboarding.setup');
    },
    onError: (err) => {
      track(site, 'Development Plan Activation Failed', {
        error_message: err instanceof Error ? err.message : String(err),
      });
      options.onError?.(err);
    },
  });
}
